import React from 'react';
import './SyntheseRating.scss';
import '../SyntheseTabs/SyntheseTab.scss';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store/store/store';
import { FicheAutocontrole } from '../../../store/types/FicheAutocontrole.Types';
import StarIcon from '@material-ui/icons/Star';
import StarOutlineIcon from '@material-ui/icons/StarBorderOutlined';
import Rating from '@material-ui/lab/Rating';
import { Typography, withStyles } from '@material-ui/core';

// Personnalisation du composant Rating
const StyledRating = withStyles({
  iconFilled: {
    color: '#7d1e4f',
  },
  iconHover: {
    color: '#7d1e4f',
  },
})(Rating);

interface Props {
  ficheAutocontrole: FicheAutocontrole;
}

const SyntheseRating: React.FC<Props> = ({ ficheAutocontrole }) => {
  const calculateAverageRating = (critere: FicheAutocontrole): number => {
    const ratingValues: number[] = [];

    critere.tabs.forEach(tab => {
      tab.groups?.forEach(group => {
        group.criterias?.forEach(criteria => {
          if (criteria.ratingValue !== undefined && criteria.ratingValue !== null && criteria.activated === true && criteria.isQualityRating === true) {
            ratingValues.push(criteria.ratingValue);
          }
        });
      });
    });

    const totalRating = ratingValues.reduce((acc, val) => acc + val, 0);

    const ratingActive = critere.tabs.flatMap(tab =>
      tab.groups?.flatMap(group =>
        group.criterias?.filter(criteria => criteria.isQualityRating === true && criteria.activated === true) || []
      ) || []
    );

    const moyenne = totalRating / (ratingActive.length || 1); // éviter division par zéro
    return moyenne;
  };

  const moyenne = calculateAverageRating(ficheAutocontrole);

  return (
    <div className="synthese-tab">
      <div className="synthese-tab-header-rating">
        <div className="rating-container">
          <Typography className="synthese-tab-title" style={{ fontWeight: 'bold' }}>
            Appréciation DQPL :
          </Typography>
          <StyledRating
            name="rating-customized"
            size="large"
            icon={<StarIcon style={{ fontSize: 40 }} />}
            emptyIcon={<StarOutlineIcon style={{ fontSize: 40, color: '#7d1e4f' }} />}
            value={moyenne}
            precision={1}
            readOnly
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ ficheAutocontrole }: ApplicationState) => ({
  ficheAutocontrole: ficheAutocontrole.data,
});

export default connect(mapStateToProps)(SyntheseRating);